
























































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '../../../../../components/Modal.vue'
import { TransactionsModule } from '@/store/modules/transactions.module'
import { getModule } from 'vuex-module-decorators'
import ScrollView from '@/components/ScrollView.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { formatDate } from '@/constants'
import Card from '@/components/Card.vue'
import { EClaimTaskStatus } from '@zunta/configurations'
import StatusClaimTask from '@/components/statuses/StatusClaimTask.vue'

@Component({
  components: { StatusClaimTask, Card, ScrollView, Modal, DateTimeLabel },
  props: {
    selectedTED: {
      type: Object
    },
    transactionLineItems: {
      type: Array
    }
  }
})
export default class CollectionsLineItemsModal extends Vue {
  transactionsModuleInstance: TransactionsModule = getModule(TransactionsModule, this.$store)
  EClaimTaskStatus: any = EClaimTaskStatus
  formatDate: any = formatDate
  rowNum: number = -1

  isTransactionLineItemsLoading: boolean = false
  isLoading: boolean = false

  async mounted () {
    await this.getTEDLineItems()
  }

  async getTEDLineItems () {
    this.transactionsModuleInstance.SET_TRANSACTION_LINE_ITEMS([])
    try {
      this.isTransactionLineItemsLoading = true
      await this.transactionsModuleInstance.getTransactionLineItems(this.$props.selectedTED.id)
    } finally {
      this.isTransactionLineItemsLoading = false
    }
  }

  toggleRowNum (index: number) {
    this.rowNum = this.rowNum === index ? -1 : index
  }
}
